<template>
    <ion-page>
        <ion-loading :is-open="loading" message="Loading, please wait"/>
        <standard-header title="Receive Item" align="middle"/>
        <ion-content class="ion-padding">
            <ion-label v-if="upliftLine.amazon_uplift">{{ upliftLine.amazon_uplift.data.amazon_reference }}</ion-label>
            <ion-item>
                <p>Received So Far</p>
                <p slot="end">{{upliftLine.qty_received}}</p>
            </ion-item>
            <ion-item class="ion-padding-top" lines="none">
                <big-stepper label="Qty Received" v-model="qty_received" />
            </ion-item>
        </ion-content>
        <ion-footer>
            <ion-button color="warning" class="ion-margin-top" size="large" expand="full" @click="progress">
                Update Uplift
            </ion-button>
        </ion-footer>
    </ion-page>
</template>

<script>
import {IonButton, IonContent, IonFooter, IonItem, IonLabel, IonLoading, IonPage} from "@ionic/vue";
import StandardHeader from "../../../../components/StandardHeader";
import BigStepper from "../../../../components/BigStepper";

export default {
    name: "Received.vue",
    props: {
        item: {
            type: Object
        },
    },
    watch: {
        params(val){
            if(val.upliftLineId) {
                this.refresh()
            }
        }
    },
    inject: ['$http', '$toast','$validationAlert'],
    mounted() {
      this.refresh();
    },
    computed: {
        params(){
            return this.$route.params
        },
        include(){
            return 'amazon_uplift'
        }
    },
    methods: {
        refresh(){
            this.loading = true;
            this.qty_received = 0;
            this.$http.get(
                `/api/uplift-lines/${this.params.upliftLineId}`, {
                    params: {
                        include: this.include
                    }
                }
            ).then(response => {
                this.upliftLine = response.data.data
                this.loading = false
            }).catch(error => {
                this.loading = false
            })
        },
        progress(){
            this.$router.push({
                name: 'warehouse.uplifts.update', params: {
                    id: this.upliftLine.id,
                    qty_received: this.qty_received,
                    upliftItemName: this.upliftLine.description,
                    upliftItemSku: this.upliftLine.sku
                }});
        }
    },
    data(){
        return {
            upliftLine: {},
            qty_received: 0,
            loading: false
        }
    },
    components: {
        IonPage,
        StandardHeader,
        IonLabel,
        IonContent,
        IonItem,
        BigStepper,
        IonFooter,
        IonButton,
        IonLoading
    }
}
</script>

<style scoped>

</style>